import { ShopModal } from '@/components/modals';

interface ShopScreenProps {
  onGoHome: () => void;
}

function ShopScreen({ onGoHome }: ShopScreenProps) {
  return (
    <ShopModal
      isOpen={true} // Always open on mobile since this IS the shop screen
      onClose={onGoHome}
    />
  );
}

export default ShopScreen;
